import i18n from '../i18n/i18n'
import { dateFormat } from './dateHelper'
import queueToast from '@/helpers/queueToast'

const mixins = {
  computed: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent || navigator.vendor || window.opera
        )
      ) {
        return true
      } else return false
    },
    isAdmin() {
      let userPermissions = this.$store.state.permissions.userRolePermissions
      let isAdmin = userPermissions.some(role => role.type == 'all')
      return isAdmin
    },
    isParticipant() {
      let userPermissions = this.$store.state.permissions.userRolePermissions
      let hasRole = userPermissions.some(role => role.type == 'participant')
      return hasRole
    }
  },
  methods: {
    nextTick(callback, timeout) {
      this.$nextTick(_ => {
        this.$nextTick(_ => {
          this.$nextTick(_ => {
            setTimeout(() => callback(), timeout || 0)
          })
        })
      })
    },
    async validate() {
      try {
        const result = await this.$validator.validateAll()
        if (result) return true

        let message = i18n.t('error.validationError')
        queueToast([message])

        return false
      } catch (error) {
        return false
      }
    },
    can(action, model, object) {
      try {
        if (!action || !model) return false
        if (object && typeof object !== 'object') return false
        if (object && !Object.keys(object).length) return false
        if (this.isAdmin || this.isCreator(object)) return true

        let ws = action.toUpperCase() + '_'
        ws +=
          action == 'list'
            ? i18n.tc(model, 2, 'en').toUpperCase()
            : model.toUpperCase()

        let userPermissions = this.$store.state.permissions.userRolePermissions

        let hasPermission = userPermissions.some(role => {
          return role.webservices.some(webservice => {
            return (
              webservice === ws ||
              (action === 'list' &&
                webservice === `LIST_${model.toUpperCase()}`)
            )
          })
        })
        if (hasPermission) {
          if (action === 'create' || action === 'list') hasPermission = true
          else if (object && (object._id || object.value)) {
            hasPermission = userPermissions.some(role => {
              let isValid = false

              // Permisos directos
              if (role.objectId.includes(object._id || object.value))
                isValid = true
              else {
                // Permisos indirectos
                if (model == 'team' && role.type == 'entities') {
                  isValid = role.objectId.includes(object.entityId)
                }

                if (
                  !isValid &&
                  model == 'user' &&
                  (role.type == 'entities' || role.type == 'teams')
                ) {
                  isValid = role.objectId.some(
                    objectId =>
                      object.roles &&
                      object.roles.some(userRole =>
                        userRole.objectId.includes(objectId)
                      )
                  )
                }
              }

              return isValid
            })
          }
        }
        // console.log('can', ws, hasPermission)

        return hasPermission
      } catch (error) {
        console.log(error)
        return false
      }
    },
    hasPermission(action) {
      let hasPermission = false
      let userPermissions = this.$store.state.permissions.userRolePermissions
      if (this.isAdmin) hasPermission = true
      else if (
        userPermissions.some(role => role.webservices.includes(action))
      ) {
        hasPermission = true
      }

      return hasPermission
    },
    hasRole(type, objectId) {
      if (this.isAdmin) return true

      let userPermissions = this.$store.state.permissions.userRolePermissions
      let hasRole = userPermissions.some(role => {
        let result = role.type == type
        if (objectId != undefined && result) {
          result = role.objectId.includes(objectId)
        }
        return result
      })
      return hasRole
    },

    isCreator(object) {
      if (!object || (!object.createdBy && !object.createdById)) return false
      let authUser = this.$store.state.authentication.user
      return (
        authUser &&
        (object.createdBy === authUser._id ||
          object.createdById === authUser._id)
      )
    },
    getName(item) {
      if (!item || !item.length) return ''
      const langId = this.$store.state.languages.langId()
      let result = item.find(name => name.langId === langId)
      if (!result)
        result = item.find(
          name => name.langId === this.defaultValues.languageRequire
        )
      return result ? result.text : item[0] ? item[0].text : ''
    },
    setComplexLanguage(item) {
      const defaultLangId = this.$store.state.languages.defaultLangId
      let languages = this.$store.state.languages.listLanguages
        .slice()
        .sort((a, b) => a.order - b.order)
      let itemTmp = []
      languages.forEach(language => {
        if (!language.active) return
        language.required = language._id === defaultLangId
        let result = { language, langId: language._id, text: '' }
        const itemLang = item
          ? item.find(lang => lang.langId === language._id)
          : null
        if (itemLang) {
          ;(result._id = itemLang._id), (result.text = itemLang.text)
        }
        itemTmp.push(result)
      })
      return itemTmp
    },
    getComplexLanguage(items) {
      let complex = []
      items.forEach(item => {
        if (!item.text) return
        let result = { ...item }
        delete result.language

        complex.push(result)
      })
      return complex
    },
    filterArray(array, text) {
      if (!text) return array
      let aux_array = []
      let regex = new RegExp(`${text}.*`, 'i')

      for (let i in array) {
        let temp = false
        for (let j in array[i]) {
          if (
            array[i][j] &&
            !Array.isArray(array[i][j]) &&
            regex.test(array[i][j].toString()) &&
            !temp
          ) {
            aux_array.push(array[i])
            temp = true
          }
        }
      }
      return aux_array
    },

    formatDate(date, time = false) {
      return dateFormat(date, time)
    },
    formatUser(id) {
      if (!id) return id
      const list = this.$store.state.users.listSelectUsers
      if (!list.length) return this.$t('messages.searching')
      const result = list.find(item => item.value === id)
      return result ? result.name || result.text : '*'
    },
    formatTeam(id) {
      if (!id) return id
      const list = this.$store.state.teams.listSelectTeams
      if (!list.length) return this.$t('messages.searching')
      const result = list.find(item => item.value === id)
      return result ? result.text : '*'
    },
    formatEntity(id) {
      if (!id) return id
      const list = this.$store.state.entities.listSelectEntities
      if (!list.length) return this.$t('messages.searching')
      const result = list.find(item => item.value === id)
      return result ? result.text : '*'
    },
    formatTournament(id) {
      if (!id) return id
      const list = this.$store.state.tournaments.list
      if (!list.length) return this.$t('messages.searching')
      const result = list.find(item => item._id === id)
      return result ? result.name : '*'
    },
    formatCountry(id) {
      if (!id) return id
      const list = this.$store.state.countries.list
      if (!list.length) return this.$t('messages.searching')
      const result = list.find(item => item._id === id)
      return result ? result.name : '*'
    },
    formatProvince(id) {
      if (!id) return id
      const list = this.$store.state.provinces.list
      if (!list.length) return this.$t('messages.searching')
      const result = list.find(item => item._id === id)
      return result ? result.name : '*'
    },
    formatCategory(id) {
      if (!id) return id
      const list = this.$store.getters['categories/selectList']
      if (!list.length) return this.$t('messages.searching')
      const result = list.find(item => item.value === id)
      return result ? result.text : '*'
    },
    formatPitch(id) {
      if (!id) return id
      const list = this.$store.state.stadiums.listStadiums
      if (!list.length) return this.$t('messages.searching')
      let result
      for (const item of list) {
        if (result) return
        const pitch = item.pitches.find(pitch => pitch._id === id)
        if (pitch) {
          result = `${pitch.name} (${item.name})`
        }
      }
      return result || '*'
    }
  }
}

export default mixins
